
import { Options, Vue } from 'vue-class-component';
import Footer from "@/app/ui/components/footer/index.vue";
import Whatsapp from "@/app/ui/components/lp-icon/svgs/whatsapp.vue";
import { AccountController } from '../../controllers/AccountController';
import { PHONE_NUMBER_HD } from '../../../infrastructures/misc/Constants';
import { cleanPhoneNumber } from "@/app/infrastructures/misc/common-library/Whatsapp";

@Options({
  name: "InactiveAccount",
  components: {
    Footer,
    Whatsapp
  }
})
class InactiveAccount extends Vue {
  cleanPhoneNumber = cleanPhoneNumber;

  get phoneNumberHD() {
    return PHONE_NUMBER_HD
  }

  mounted() {
    if (!AccountController.accountData.email) {
      this.$router.replace("/");
    }
  }
  unmounted() {
    AccountController.setAccountEmail("");
  }
}
export default InactiveAccount;
